﻿import { type FC } from 'react';
import AppLayout from '@/components/feature/AppLayout';

const PortalPage: FC = () => {
  return (
    <AppLayout>
      <div className="p-4 md:p-6 space-y-5">
        <div className="flex items-center gap-3">
          <h2 className="text-xl font-bold text-foreground-900">Portal do Cliente</h2>
          <span className="text-xs px-2 py-0.5 rounded-full bg-amber-50 text-amber-700 border border-amber-200 font-medium">Módulo Futuro</span>
        </div>

        <div className="bg-background-50 border border-background-200 rounded-xl p-8">
          <div className="flex flex-col items-center text-center max-w-md mx-auto">
            <div className="w-16 h-16 rounded-2xl bg-amber-50 border border-amber-200 flex items-center justify-center mb-4">
              <i className="ri-tools-line text-3xl text-amber-500"></i>
            </div>
            <h3 className="text-lg font-semibold text-foreground-900 mb-2">Em Desenvolvimento</h3>
            <p className="text-sm text-foreground-500 mb-6">
              O Portal do Cliente permitirá que seus clientes acompanhem o status dos casos, 
              visualizem documentos, contratos, façam upload de arquivos e troquem mensagens 
              diretamente pelo BM Legal OS.
            </p>

            <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6">
              {[
                { icon: 'ri-eye-line', label: 'Status do Caso', desc: 'Acompanhamento em tempo real' },
                { icon: 'ri-file-text-line', label: 'Documentos', desc: 'Contratos e procurações' },
                { icon: 'ri-upload-line', label: 'Upload', desc: 'Envio de documentos' },
                { icon: 'ri-chat-3-line', label: 'Mensagens', desc: 'Comunicação direta' },
                { icon: 'ri-bank-card-line', label: 'Cobrança', desc: 'Pagamentos online' },
                { icon: 'ri-calendar-check-line', label: 'Próximos Passos', desc: 'Cronograma do caso' },
              ].map((item) => (
                <div key={item.label} className="p-3 bg-background-100 rounded-lg text-left opacity-60">
                  <i className={`${item.icon} text-foreground-400 text-lg`}></i>
                  <p className="text-sm font-medium text-foreground-600 mt-1.5">{item.label}</p>
                  <p className="text-xs text-foreground-400">{item.desc}</p>
                </div>
              ))}
            </div>

            <div className="p-3 bg-primary-50/50 border border-primary-100 rounded-lg w-full">
              <p className="text-xs text-primary-700 font-medium">
                Previsão de lançamento: Q3 2026. Entre em contato para saber mais.
              </p>
            </div>
          </div>
        </div>
      </div>
    </AppLayout>
  );
};

export default PortalPage;
